/* eslint-disable */
// AUTO-GENERATED by scripts/sync-selkirk-icons.mjs — do not edit manually.

/** @type {Record<string, string>} */
export const ICON = {
  appAdministration: 'app-administration',
  appAssayCompositing: 'app-assay-compositing',
  appClaimManagement: 'app-claim-management',
  appDailyReport: 'app-daily-report',
  appDebug: 'app-debug',
  appDeviationWizard: 'app-deviation-wizard',
  appDocumentDesign: 'app-document-design',
  appDocusign: 'app-docusign',
  appDrillholeValidation: 'app-drillhole-validation',
  appDrillingCosts: 'app-drilling-costs',
  appDrillingDashboard: 'app-drilling-dashboard',
  appLabApprovals: 'app-lab-approvals',
  appQaqc: 'app-qaqc',
  appQgisViewer: 'app-qgis-viewer',
  appReportGenerator: 'app-report-generator',
  appSampleTracking: 'app-sample-tracking',
  appWhosIn: 'app-whos-in',
  appWolfwalker: 'app-wolfwalker',
  ddApprovedExternal: 'dd-approved-external',
  ddAssetAttachmentPlaceholder: 'dd-asset-attachment-placeholder',
  ddAssetChartPlaceholder: 'dd-asset-chart-placeholder',
  ddClose: 'dd-close',
  ddFolder: 'dd-folder',
  ddNoIssues: 'dd-no-issues',
  ddQaBlocked: 'dd-qa-blocked',
  ddTabBrandLibrary: 'dd-tab-brand-library',
  ddTabDocuments: 'dd-tab-documents',
  ddTabMediaCreator: 'dd-tab-media-creator',
  ddTreeBranch: 'dd-tree-branch',
  drillFilterProgress: 'drill-filter-progress',
  drillFilterRig: 'drill-filter-rig',
  drillFilterStatus: 'drill-filter-status',
  drillFilterZone: 'drill-filter-zone',
  launcherContactIt: 'launcher-contact-it',
  launcherError: 'launcher-error',
  launcherGroupBadge: 'launcher-group-badge',
  launcherNoApps: 'launcher-no-apps',
  launcherStatApps: 'launcher-stat-apps',
  launcherStatSecurity: 'launcher-stat-security',
  launcherStatUptime: 'launcher-stat-uptime',
  launcherStatVersion: 'launcher-stat-version',
  mapBasemapDark: 'map-basemap-dark',
  mapBasemapSatellite: 'map-basemap-satellite',
  mapBasemapStreet: 'map-basemap-street',
  mapBasemapTerrain: 'map-basemap-terrain',
  mapLayerAdd: 'map-layer-add',
  mapLayerHidden: 'map-layer-hidden',
  mapLayerRemove: 'map-layer-remove',
  mapLayerVisible: 'map-layer-visible',
  mapZoomToFeature: 'map-zoom-to-feature',
  navChevronDown: 'nav-chevron-down',
  navHelp: 'nav-help',
  navHome: 'nav-home',
  navNotifications: 'nav-notifications',
  navProfile: 'nav-profile',
  navSettings: 'nav-settings',
  navSignOut: 'nav-sign-out',
  navTheme: 'nav-theme',
  qaqcDomainBlank: 'qaqc-domain-blank',
  qaqcDomainControlStandard: 'qaqc-domain-control-standard',
  qaqcDomainDuplicate: 'qaqc-domain-duplicate',
  qaqcDomainFallback: 'qaqc-domain-fallback',
  sampleLocAir: 'sample-loc-air',
  sampleLocComplete: 'sample-loc-complete',
  sampleLocDrill: 'sample-loc-drill',
  sampleLocLab: 'sample-loc-lab',
  sampleLocOffice: 'sample-loc-office',
  sampleLocTruck: 'sample-loc-truck',
  uiAccessDenied: 'ui-access-denied',
  uiAdd: 'ui-add',
  uiApiLink: 'ui-api-link',
  uiCalculator: 'ui-calculator',
  uiCalendarDate: 'ui-calendar-date',
  uiCameraMap: 'ui-camera-map',
  uiChartAnalytics: 'ui-chart-analytics',
  uiCheckOff: 'ui-check-off',
  uiCheckOn: 'ui-check-on',
  uiClipboardList: 'ui-clipboard-list',
  uiClockEta: 'ui-clock-eta',
  uiClose: 'ui-close',
  uiDatabase: 'ui-database',
  uiDepth: 'ui-depth',
  uiDispatch: 'ui-dispatch',
  uiDocument: 'ui-document',
  uiEdit: 'ui-edit',
  uiEmptyMailbox: 'ui-empty-mailbox',
  uiError: 'ui-error',
  uiExport: 'ui-export',
  uiFilter: 'ui-filter',
  uiFolderOpen: 'ui-folder-open',
  uiGlobeLocation: 'ui-globe-location',
  uiHourglass: 'ui-hourglass',
  uiInvestigation: 'ui-investigation',
  uiLocationPin: 'ui-location-pin',
  uiNews: 'ui-news',
  uiNumbers: 'ui-numbers',
  uiPause: 'ui-pause',
  uiPointerHint: 'ui-pointer-hint',
  uiRadioOff: 'ui-radio-off',
  uiRefresh: 'ui-refresh',
  uiRemove: 'ui-remove',
  uiSearch: 'ui-search',
  uiSecurityLock: 'ui-security-lock',
  uiSequentialLeach: 'ui-sequential-leach',
  uiShift: 'ui-shift',
  uiSortAsc: 'ui-sort-asc',
  uiSortDesc: 'ui-sort-desc',
  uiSortNeutral: 'ui-sort-neutral',
  uiStar: 'ui-star',
  uiSuccess: 'ui-success',
  uiThemeDark: 'ui-theme-dark',
  uiThemeLight: 'ui-theme-light',
  uiTip: 'ui-tip',
  uiTools: 'ui-tools',
  uiTrophy: 'ui-trophy',
  uiWarning: 'ui-warning',
  uiWaveHello: 'ui-wave-hello',
  whosinTabBreakdown: 'whosin-tab-breakdown',
  whosinTabFullRoster: 'whosin-tab-full-roster',
  whosinTabOnsite: 'whosin-tab-onsite',
};
